import { render } from "./ZNZBZZYJC.vue?vue&type=template&id=18d3e7fe"
import script from "./ZNZBZZYJC.vue?vue&type=script&lang=js"
export * from "./ZNZBZZYJC.vue?vue&type=script&lang=js"

import "./ZNZBZZYJC.vue?vue&type=style&index=0&id=18d3e7fe&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__